import { FormFactor } from '../../types';
import { getScreenType } from '../../utils/getScreenType';
import { useResizeObserver } from '../useResizeObserver';

export function useScreenSize(isReturnWidth: true): number;
export function useScreenSize(isReturnWidth?: undefined | false): FormFactor;
export function useScreenSize(isReturnWidth?: boolean): number | FormFactor {
  const [screenWidth, screenHeight] = useResizeObserver();
  const { userAgent } = window.navigator;
  const isWindows = userAgent.toLocaleLowerCase().includes('windows');

  if (isWindows && screenHeight > window.outerHeight) {
    const width = window.innerWidth;
    return isReturnWidth ? width : getScreenType();
  }

  return isReturnWidth ? screenWidth : getScreenType();
}
